import { Injectable } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { IOfficeFormMetadata } from '../models/office-data.model';
import { OfficeGridData } from '../SingleGridForm/single-grid.model';

@Injectable({
  providedIn: 'root',
})
export class OfficeDataService {
  private _handler: Subject<string> = new Subject<string>();

  boradcast(text: string) {
    this._handler.next(text);
  }

  subscribe(callback: (text: any) => void): Subscription {
    return this._handler.subscribe(callback);
  }
  /* SGF - SingleGridForm
   * RGW - ReportGateway*/
  public OfficeNavBarOn = false;
  public ModalMsg = 'Please Wait ...';
  public SGFSubOn = false;
  public SGFIsNewRow = null;
  public SGFCompany = null;
  public SGFCompanyList = [];
  public SGFFormList = [];
  public SGFMode = null;
  public SGFTitle = null;
  public SGFStaticLookupsResponse: [{ [key: string]: any }];
  public SGFRoute = null;
  public SGFSortList = [];
  public SGFFilteringList = {};

  public SGFFormMetadata: IOfficeFormMetadata;
  public SGFRowDataEdit: OfficeGridData = null;
  public SGFFormData = [];
  public SGFCombobox = {};
  public SGFCurrentFormReadOnly = false;
  public SGFForm = null;

  public SGFRelatedFormMetadata: IOfficeFormMetadata;
  public SGFRelatedRowDataEdit: OfficeGridData = null;
  public SGFRelatedFormData = [];
  public SGFRelatedCombobox = {};
  public SGFCurrentRelatedFormReadOnly = false;
  public SGFRelatedTabGridForm = null;
  public SGFRelatedTabParentRowdata = null;
  public SGFRelatedTitle = null;

  public RGWSubOn = false;
  public RGWCat = 'All';
  constructor() {}
}
